var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ofi-list"},_vm._l((_vm.properties),function(property,index){return _c('propertyItem',{key:property.id || index,attrs:{"index":index,"property":property,"screen-mode":_vm.screenMode}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }